import Homepage from "./components/Homepage";
import About from "./components/About";
import Galery from "./components/Galery";
import Sacrificed from "./components/Sacrificed";
import Contact from "./components/Contact";

export const routes = [
  { path: "/Anasayfa", component: Homepage},
  { path: "/Hakkimizda", component: About },
  { path: "/Galeri", component: Galery },
  { path: "/SSS", component: Sacrificed },
  { path: "/Iletisim", component: Contact },
  { path: "*", component: Homepage }
];



// WEBPACK FOOTER //
// ./src/route.js